import InviteOrgCompletePage from "./InviteOrgCompletePage";

export default InviteOrgCompletePage;
